import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ForgePageLoader } from "@/components/ForgeLoader";
import { usePermissions } from "@/hooks/usePermissions";
import { hasQboFinanceReadAccess } from "@/lib/qbo-finance-access";

export function QboFinanceRouteGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { orgAppRolesDbOnly, isOrgAdmin, isLoading } = usePermissions();
  if (isLoading) return <ForgePageLoader />;
  if (!hasQboFinanceReadAccess(orgAppRolesDbOnly, isOrgAdmin)) {
    return <Navigate to="/403" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
